import { render, staticRenderFns } from "./ModalWithdrawRewards.vue?vue&type=template&id=5dd0bca5&"
import script from "./ModalWithdrawRewards.vue?vue&type=script&lang=js&"
export * from "./ModalWithdrawRewards.vue?vue&type=script&lang=js&"
import style0 from "./ModalWithdrawRewards.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports